import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getSelectedCustomerSelector } from '@sophocles/features/auth/authSelectors';
import { tAlarm } from '@sophocles/utils/alarmTranslation';

/**
 * Returns a `t` function that automatically applies the commercial-tenant
 * override when the selected customer is non-billboard. Use for any
 * `alarms.*` key lookup in functional components.
 */
export function useAlarmTranslation() {
  const { t } = useTranslation();
  const customer = useSelector(getSelectedCustomerSelector);
  const isBillboard = customer.get('is_billboard', true);
  return useCallback((key, options) => tAlarm(t, key, isBillboard, options), [t, isBillboard]);
}
